export const HkiaMapInformation = {
  venue: "HKIA",
  venueId: "b4ed5551-8356-4b38-ae30-6b6b30d094f4",
  i18nVenue: "venue_hkia",
  venueName: "HKIA",
  venueName_zh: "HKIA",
  avatar:
    "https://assets.deepworldmodel.ai/navigation/avatar/security_robot_20260811_1445.glb",
  avatarIsFloating: false,
  floorAlignment: [
    {
      id: "0590e405-25f5-4cae-ba42-90e92ec04153",
      lcMapId: "ebbac3b3-6c85-497a-b1ea-3003d5954e83",
      lcMapName: "T1 Bus Station & Carpark1 Coach bay -30",
      name: "Carpark1_Level 3",
      ordinal: 3,
      shortName: "L3",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981080049_0fb0.png",
      pixInMeter: 3.0468861405343777,
      size: { width: 10322, height: 10322 },
      angle: 251.00332255258135,
      scale: 328.2039314682453,
      center: { lat: 22.32114059358897, lng: 113.92785014057097 },
      corners: {
        bl: { lat: 22.311694836097693, lng: 113.94878026972663 },
        br: { lat: 22.34050359125054, lng: 113.93806056803635 },
        tl: { lat: 22.30177916816407, lng: 113.91764054456519 },
        tr: { lat: 22.33058477884359, lng: 113.90691917995582 },
      },
      sizeInMeters: { width: 3387.5962061283367, height: 3387.546081103483 },
      lcBound: [
        [113.9365419825574, 22.311658890540432],
        [113.93454620002399, 22.31693869258255],
        [113.93626747950464, 22.3174955498902],
        [113.93826324552674, 22.312215715947474],
        [113.9365419825574, 22.311658890540432],
      ],
    },
    {
      id: "07a7b6c2-0a22-4e23-89a8-679a7f38070b",
      lcMapId: "0bdb2c4b-3c65-44dd-a45e-35b28fa98179",
      lcMapName: "Skypier APM Platform-10",
      name: "Skypier_Level 1",
      ordinal: 1,
      shortName: "L1",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786982496323_ec2a.png",
      pixInMeter: 3.0272664900322006,
      size: { width: 10322, height: 10322 },
      angle: 250.9146469528687,
      scale: 330.33101429117823,
      center: { lat: 22.32121321258414, lng: 113.92787284701978 },
      corners: {
        bl: { lat: 22.31173640474983, lng: 113.94895451424804 },
        br: { lat: 22.340716395328478, lng: 113.93811683698198 },
        tl: { lat: 22.301711621676983, lng: 113.91762969319257 },
        tr: { lat: 22.33068842858121, lng: 113.90679034365667 },
      },
      sizeInMeters: { width: 3409.5506054874263, height: 3409.4996491611205 },
      lcBound: [
        [113.94300800131418, 22.31778362122821],
        [113.942812664764, 22.318300368587437],
        [113.94367787675321, 22.318580263176216],
        [113.94387321249076, 22.31806351424736],
        [113.94300800131418, 22.31778362122821],
      ],
    },
    {
      id: "07ed256f-fd6a-4d75-87a6-6545733d29ca",
      lcMapId: "049d1110-ef7b-4273-8d0e-7bc3aff284b2",
      lcMapName: "MFC _ L7-70",
      name: "MFC_Level 7",
      ordinal: 7,
      shortName: "L7",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980626177_4d57.png",
      pixInMeter: 3.0539579092650824,
      size: { width: 10322, height: 10322 },
      angle: 251.06350579117003,
      scale: 327.44588275674124,
      center: { lat: 22.320995427088125, lng: 113.9276144562433 },
      corners: {
        bl: { lat: 22.311551034830256, lng: 113.9484860969178 },
        br: { lat: 22.340303168326837, lng: 113.93782297055077 },
        tl: { lat: 22.301687685849412, lng: 113.91740760509902 },
        tr: { lat: 22.330436688342292, lng: 113.9067428155688 },
      },
      sizeInMeters: { width: 3379.7519734301145, height: 3379.702197178159 },
      lcBound: [
        [113.9174408585435, 22.309198269614562],
        [113.91703163955117, 22.310279337593418],
        [113.91820928894572, 22.310660875248374],
        [113.91861850562975, 22.30957980280084],
        [113.9174408585435, 22.309198269614562],
      ],
    },
    {
      id: "15b1dfeb-efcf-4f0a-bd29-0cc6d2fa363d",
      lcMapId: "3ac50d06-fad6-4138-bc28-153322583a00",
      lcMapName: "L4-NSC & Skybridge-40",
      name: "NSC_Level 4",
      ordinal: 4,
      shortName: "L4",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981051729_366f.jpg",
      pixInMeter: 3.121371766874,
      size: { width: 10322, height: 10322 },
      angle: 251.00165630122288,
      scale: 320.371966004716,
      center: { lat: 22.32097792982195, lng: 113.92793319018358 },
      corners: {
        bl: { lat: 22.311758145414913, lng: 113.94836413718997 },
        br: { lat: 22.3398791160007, lng: 113.93789934958181 },
        tl: { lat: 22.302078241711175, lng: 113.91796782292033 },
        tr: { lat: 22.330196216161063, lng: 113.90750145104244 },
      },
      sizeInMeters: { width: 3306.7605498690205, height: 3306.7127859951647 },
      lcBound: [
        [113.93013587650432, 22.316531567651285],
        [113.92963798350127, 22.31784871152487],
        [113.93059426539662, 22.318158070045406],
        [113.93109215611094, 22.316840921750032],
        [113.93013587650432, 22.316531567651285],
      ],
    },
    {
      id: "1cefdb09-17d9-4f29-bc20-d3b5a26e5462",
      lcMapId: "0afc009c-3f6c-4f0b-b94e-f1b791e5f9a5",
      lcMapName: "T2 L6 AEL (Departure) -60",
      name: "T2CoachHall_Level 6",
      ordinal: 6,
      shortName: "L6",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980969854_5f2c.png",
      pixInMeter: 3.0272848441759934,
      size: { width: 10322, height: 10322 },
      angle: 250.91296662126882,
      scale: 330.32901152556286,
      center: { lat: 22.321167450666884, lng: 113.92778090932097 },
      corners: {
        bl: { lat: 22.311691272257626, lng: 113.94886274228736 },
        br: { lat: 22.340670793046545, lng: 113.93802421547252 },
        tl: { lat: 22.30166570008538, lng: 113.91753843917581 },
        tr: { lat: 22.330642037278018, lng: 113.90669824034853 },
      },
      sizeInMeters: { width: 3409.52993994881, height: 3409.478980967089 },
      lcBound: [
        [113.93726759187018, 22.31330787932893],
        [113.93535418423869, 22.31836930356436],
        [113.93922590084435, 22.319621923213056],
        [113.94113927287253, 22.314560430184443],
        [113.93726759187018, 22.31330787932893],
      ],
    },
    {
      id: "2d339cdd-32ed-46d4-90e1-6127cc08a9c2",
      lcMapId: "960dbfd1-15e1-445b-a1a9-35271aa17537",
      lcMapName: "T2 L1 APM Platform -10",
      name: "T2CoachHall_Level 1",
      ordinal: 1,
      shortName: "L1",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786982496323_ec2a.png",
      pixInMeter: 3.067475413673732,
      size: { width: 10322, height: 10322 },
      angle: 250.91462492410207,
      scale: 326.00098617258317,
      center: { lat: 22.32108728700125, lng: 113.92787285784118 },
      corners: {
        bl: { lat: 22.311734720269843, lng: 113.94867817396232 },
        br: { lat: 22.340334812422967, lng: 113.93798254551518 },
        tl: { lat: 22.301841311948277, lng: 113.91776398451827 },
        tr: { lat: 22.330438303363923, lng: 113.90706672736917 },
      },
      sizeInMeters: { width: 3364.8593417726443, height: 3364.8097129641437 },
      lcBound: [
        [113.93731145365757, 22.313309798008188],
        [113.93538617480101, 22.31840179613471],
        [113.93928127963818, 22.319662187273597],
        [113.94120652246738, 22.314570119519022],
        [113.93731145365757, 22.313309798008188],
      ],
    },
    {
      id: "2edf4f0b-d447-4e86-943a-ac18ad124a69",
      lcMapId: "642cd35f-a687-4697-a3ef-3e217ccb22f6",
      lcMapName: "T2 L2 Transfer Area -20",
      name: "T2CoachHall_Level 2",
      ordinal: 2,
      shortName: "L2",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786982432987_6f93.png",
      pixInMeter: 3.0674941024875273,
      size: { width: 10322, height: 10322 },
      angle: 250.91462492410207,
      scale: 326.00098617258317,
      center: { lat: 22.321087287001255, lng: 113.9278777186646 },
      corners: {
        bl: { lat: 22.31173455915231, lng: 113.9486836076668 },
        br: { lat: 22.340334190634845, lng: 113.93798714956745 },
        tl: { lat: 22.30184038336766, lng: 113.91776991621987 },
        tr: { lat: 22.3304369141817, lng: 113.90707182966241 },
      },
      sizeInMeters: { width: 3364.8388469886213, height: 3364.789215526198 },
      lcBound: [
        [113.93732582830899, 22.313334819688013],
        [113.9354099058504, 22.318397167005905],
        [113.93928232933274, 22.319651432741935],
        [113.9411982162269, 22.31458901659719],
        [113.93732582830899, 22.313334819688013],
      ],
    },
    {
      id: "45fb80c6-e13e-48c5-a431-0a1d33d20909",
      lcMapId: "06de22a6-3392-405b-b93d-60709e1019cc",
      lcMapName: "T2 L3 Immigration Hall -30",
      name: "T2CoachHall_Level 3",
      ordinal: 3,
      shortName: "L3",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981080049_0fb0.png",
      pixInMeter: 3.0674941024875273,
      size: { width: 10322, height: 10322 },
      angle: 250.91296662126882,
      scale: 325.999,
      center: { lat: 22.321086511834142, lng: 113.9278781257791 },
      corners: {
        bl: { lat: 22.31173455915231, lng: 113.9486836076668 },
        br: { lat: 22.340334190634845, lng: 113.93798714956745 },
        tl: { lat: 22.30184038336766, lng: 113.91776991621987 },
        tr: { lat: 22.3304369141817, lng: 113.90707182966241 },
      },
      sizeInMeters: { width: 3364.8388469886213, height: 3364.789215526198 },
      lcBound: [
        [113.93538242476325, 22.318387184240304],
        [113.93926586470832, 22.31965041602292],
        [113.94119554297333, 22.314573612494737],
        [113.93731209005796, 22.313310356361114],
        [113.93538242476325, 22.318387184240304],
      ],
    },
    {
      id: "466904b6-b658-4a56-b70f-ff508c93a531",
      lcMapId: "603c72ff-b2cb-4c2b-ad70-1e116dacf9c4",
      lcMapName: "T1 Link Bridge to Carpark4 L3-30",
      name: "Carpark4_Level 3",
      ordinal: 3,
      shortName: "L3",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981080049_0fb0.png",
      pixInMeter: 3.0469043870544934,
      size: { width: 10322, height: 10322 },
      angle: 251.00165630122288,
      scale: 328.20196600471434,
      center: { lat: 22.321153297292902, lng: 113.92785541706485 },
      corners: {
        bl: { lat: 22.311708159464214, lng: 113.94878571975642 },
        br: { lat: 22.34051645365102, lng: 113.93806517556106 },
        tl: { lat: 22.30179171313785, lng: 113.91764648990511 },
        tr: { lat: 22.330596862918508, lng: 113.90692428303691 },
      },
      sizeInMeters: { width: 3387.5759251132895, height: 3387.5257973218886 },
      lcBound: [
        [113.93400447977172, 22.31645802137733],
        [113.93356334978455, 22.317623327468453],
        [113.93520546843979, 22.318155317071565],
        [113.93564659495621, 22.3169900042616],
        [113.93400447977172, 22.31645802137733],
      ],
    },
    {
      id: "52e0677d-4fec-482d-8b25-d23c6fa3d25a",
      lcMapId: "02746beb-f403-42c9-a68c-d14442872a5a",
      lcMapName: "T1 L1 APM Platform (East)-10",
      name: "T1_Level 1",
      ordinal: 1,
      shortName: "L1",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786982496323_ec2a.png",
      pixInMeter: 3.027266490036975,
      size: { width: 10322, height: 10322 },
      angle: 250.9146469528687,
      scale: 330.33101429117823,
      center: { lat: 22.321168246565964, lng: 113.9277999346225 },
      corners: {
        bl: { lat: 22.31169143873344, lng: 113.94888159505888 },
        br: { lat: 22.340671429308546, lng: 113.938043921283 },
        tl: { lat: 22.30166665565706, lng: 113.91755678409493 },
        tr: { lat: 22.33064346256483, lng: 113.9067174380533 },
      },
      sizeInMeters: { width: 3409.5506057725215, height: 3409.4996495560886 },
      lcBound: [
        [113.93321529734533, 22.3145366101232],
        [113.93295945431362, 22.315213436279393],
        [113.93428608349973, 22.315642608354725],
        [113.93454192490026, 22.314965779046684],
        [113.93321529734533, 22.3145366101232],
      ],
    },
    {
      id: "52e0677d-4fec-482d-8b25-d23c6fa3d25a",
      lcMapId: "e9052fa6-2005-4b54-b4b1-28eaa6f41d9d",
      lcMapName: "T1L1` APM Platform (West)-10",
      name: "T1_Level 1",
      ordinal: 1,
      shortName: "L1",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786982496323_ec2a.png",
      pixInMeter: 3.027266490036975,
      size: { width: 10322, height: 10322 },
      angle: 250.9146469528687,
      scale: 330.33101429117823,
      center: { lat: 22.321168246565964, lng: 113.9277999346225 },
      corners: {
        bl: { lat: 22.31169143873344, lng: 113.94888159505888 },
        br: { lat: 22.340671429308546, lng: 113.938043921283 },
        tl: { lat: 22.30166665565706, lng: 113.91755678409493 },
        tr: { lat: 22.33064346256483, lng: 113.9067174380533 },
      },
      sizeInMeters: { width: 3409.5506057725215, height: 3409.4996495560886 },
      lcBound: [
        [113.92664150331098, 22.312431270366226],
        [113.92640371090431, 22.313060353571874],
        [113.92775460558391, 22.31349738223088],
        [113.92799239644671, 22.31286829604239],
        [113.92664150331098, 22.312431270366226],
      ],
    },
    {
      id: "5c11661d-b37c-4353-8599-58d823066ce5",
      lcMapId: "72eefd8c-eb60-4929-8f16-adff1bf98451",
      lcMapName: "L8 Restaurant-80",
      name: "T1_Level 8",
      ordinal: 8,
      shortName: "L8",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786979684092_7659.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.93455600461584, 22.3143242037942],
        [113.93387569887977, 22.3161239384888],
        [113.93437901356936, 22.31628676422309],
        [113.93505931765958, 22.314487026348896],
        [113.93455600461584, 22.3143242037942],
      ],
    },
    {
      ////////
      id: "5c11661d-b37c-4353-8599-58d823066ce5",
      lcMapId: "7f3d0703-3780-420e-859c-826908ad4d88",
      lcMapName: "L8 Bus Kerb-80",
      name: "T1_Level 8",
      ordinal: 8,
      shortName: "L8",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786979684092_7659.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.936052554919, 22.314227867069487],
        [113.93498091601066, 22.31706285508734],
        [113.93561026778184, 22.317266454985067],
        [113.93668190344852, 22.314431460703908],
        [113.936052554919, 22.314227867069487],
      ],
    },
    {
      id: "5d7831ee-e7f0-49ce-872a-a9cecf385e6e",
      lcMapId: "09c06847-2f22-4d79-b582-b0382c2cdbd3",
      lcMapName: "L3_Skypier & ITT -30",
      name: "Skypier_Level 3",
      ordinal: 3,
      shortName: "L3",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981080049_0fb0.png",
      pixInMeter: 3.027248141148277,
      size: { width: 10322, height: 10322 },
      angle: 251.01632723639472,
      scale: 330.33301651085924,
      center: { lat: 22.321239189472912, lng: 113.92787437328559 },
      corners: {
        bl: { lat: 22.311727728411505, lng: 113.94893795658254 },
        br: { lat: 22.340725643461113, lng: 113.93815582829632 },
        tl: { lat: 22.301754328318182, lng: 113.91759376146115 },
        tr: { lat: 22.330749057700853, lng: 113.90680994680247 },
      },
      sizeInMeters: { width: 3409.570956619355, height: 3409.5202051688793 },
      lcBound: [
        [113.94301206591456, 22.31637394333477],
        [113.94228061569402, 22.318308933036782],
        [113.94446640959404, 22.319016040597244],
        [113.94519785212913, 22.31708103604695],
        [113.94301206591456, 22.31637394333477],
      ],
    },
    {
      id: "7b1ba8cf-6c71-4e6e-a2e8-e63145b3be74",
      lcMapId: "b54a4b38-be61-4d19-9880-c6ee19fa60c3",
      lcMapName: "MFC North-50",
      name: "MFC_Level 5",
      ordinal: 5,
      shortName: "L5",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981022417_8276.png",
      pixInMeter: 3.0539579092650824,
      size: { width: 10322, height: 10322 },
      angle: 251.06184559583286,
      scale: 327.4439398737207,
      center: { lat: 22.320994644337205, lng: 113.92761487203404 },
      corners: {
        bl: { lat: 22.311551034830256, lng: 113.9484860969178 },
        br: { lat: 22.340303168326837, lng: 113.93782297055077 },
        tl: { lat: 22.301687685849412, lng: 113.91740760509902 },
        tr: { lat: 22.330436688342292, lng: 113.9067428155688 },
      },
      sizeInMeters: { width: 3379.7519734301145, height: 3379.702197178159 },
      lcBound: [
        [113.9172979976014, 22.309520265896577],
        [113.91592854099463, 22.31314309854934],
        [113.9171397789504, 22.313534969500257],
        [113.91850922758636, 22.309912121446295],
        [113.9172979976014, 22.309520265896577],
      ],
    },
    {
      id: "7b1ba8cf-6c71-4e6e-a2e8-e63145b3be74",
      lcMapId: "a614eb56-a7d6-4961-9433-95621a8474ab",
      lcMapName: "MFC South-50",
      name: "MFC_Level 5",
      ordinal: 5,
      shortName: "L5",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981022417_8276.png",
      pixInMeter: 3.0539579092650824,
      size: { width: 10322, height: 10322 },
      angle: 251.06184559583286,
      scale: 327.4439398737207,
      center: { lat: 22.320994644337205, lng: 113.92761487203404 },
      corners: {
        bl: { lat: 22.311551034830256, lng: 113.9484860969178 },
        br: { lat: 22.340303168326837, lng: 113.93782297055077 },
        tl: { lat: 22.301687685849412, lng: 113.91740760509902 },
        tr: { lat: 22.330436688342292, lng: 113.9067428155688 },
      },
      sizeInMeters: { width: 3379.7519734301145, height: 3379.702197178159 },
      lcBound: [
        [113.91837878993624, 22.306652662354665],
        [113.91714099793, 22.30992725366055],
        [113.91836435160224, 22.31032305239355],
        [113.91960213633286, 22.307048447029576],
        [113.91837878993624, 22.306652662354665],
      ],
    },
    {
      id: "7c876b65-120b-43d6-a6b4-393336d7aed8",
      lcMapId: "482f719a-ddf9-40f0-816e-9adc36651530",
      lcMapName: "T1 SouthConcourse, NorthConcourse, East Hall-60",
      name: "T1_Level 6",
      ordinal: 6,
      shortName: "L6",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980969854_5f2c.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.93407512744261, 22.311745469409576],
        [113.93178202252011, 22.317811601693045],
        [113.93356705399117, 22.318389103382735],
        [113.93586013924119, 22.312322933089238],
        [113.93407512744261, 22.311745469409576],
      ],
    },
    {
      id: "7c876b65-120b-43d6-a6b4-393336d7aed8",
      lcMapId: "1ded34ae-ad26-467b-a1aa-47571c7e296a",
      lcMapName: "T1 Central Concourse-60",
      name: "T1_Level 6",
      ordinal: 6,
      shortName: "L6",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980969854_5f2c.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.92751592357467, 22.312476892734235],
        [113.92714541655869, 22.313457015245145],
        [113.93311365997295, 22.31538786047432],
        [113.93348415636194, 22.314407717430488],
        [113.92751592357467, 22.312476892734235],
      ],
    },
    {
      id: "7c876b65-120b-43d6-a6b4-393336d7aed8",
      lcMapId: "dd39c61e-5789-4ec3-8f5e-d71c51fe7ffd",
      lcMapName: "T1 NorthWest Concourse-60",
      name: "T1_Level 6",
      ordinal: 6,
      shortName: "L6",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980969854_5f2c.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.92368225470238, 22.312559911753226],
        [113.92277141133741, 22.314969516141463],
        [113.9262412769026, 22.316092052282098],
        [113.92715210507743, 22.313682418545408],
        [113.92368225470238, 22.312559911753226],
      ],
    },
    {
      id: "7c876b65-120b-43d6-a6b4-393336d7aed8",
      lcMapId: "4df431eb-44fa-449d-8786-6675e2dc8146",
      lcMapName: "T1 SouthWest Concourse-60",
      name: "T1_Level 6",
      ordinal: 6,
      shortName: "L6",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980969854_5f2c.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.9253283517395, 22.30926001365856],
        [113.92446424004197, 22.311546049823388],
        [113.92762741691922, 22.312569393543388],
        [113.92849151548137, 22.310283331999795],
        [113.9253283517395, 22.30926001365856],
      ],
    },
    {
      id: "7c876b65-120b-43d6-a6b4-393336d7aed8",
      lcMapId: "6e1c2815-836c-41a7-82b8-a317a6f2eed1",
      lcMapName: "T1 West Hall-60",
      name: "T1_Level 6",
      ordinal: 6,
      shortName: "L6",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980969854_5f2c.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.92647991854813, 22.311684015751037],
        [113.92580794246362, 22.313461736115094],
        [113.92759901687214, 22.31404117098134],
        [113.92827098717225, 22.312263439441548],
        [113.92647991854813, 22.311684015751037],
      ],
    },
    {
      id: "805966d3-e4ad-433b-87cd-47a689a83f8f",
      lcMapId: "781d3ab3-867c-4841-8b5e-010f3add87d2",
      lcMapName: "T1 L4_APV Floor-40",
      name: "T1_Level 4",
      ordinal: 4,
      shortName: "L4",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981051729_366f.jpg",
      pixInMeter: 3.0390334463820023,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115205272876, lng: 113.92782035274024 },
      corners: {
        bl: { lat: 22.31170616896825, lng: 113.94881735167314 },
        br: { lat: 22.340576911437104, lng: 113.93803091320649 },
        tl: { lat: 22.301728773712036, lng: 113.91761062311457 },
        tr: { lat: 22.330596356797624, lng: 113.90682252296676 },
      },
      sizeInMeters: { width: 3396.349463445795, height: 3396.2989352503196 },
      lcBound: [
        [113.93355879694957, 22.313471869898024],
        [113.93247279058028, 22.316344870276968],
        [113.93385406670484, 22.316791725244897],
        [113.934940065864, 22.313918710935717],
        [113.93355879694957, 22.313471869898024],
      ],
    },
    {
      id: "805966d3-e4ad-433b-87cd-47a689a83f8f",
      lcMapId: "e6919554-92f3-4188-9c18-76a682ba001f",
      lcMapName: "T1 L4_Floor interchange(west)-40",
      name: "T1_Level 4",
      ordinal: 4,
      shortName: "L4",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981051729_366f.jpg",
      pixInMeter: 3.0390334463820023,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115205272876, lng: 113.92782035274024 },
      corners: {
        bl: { lat: 22.31170616896825, lng: 113.94881735167314 },
        br: { lat: 22.340576911437104, lng: 113.93803091320649 },
        tl: { lat: 22.301728773712036, lng: 113.91761062311457 },
        tr: { lat: 22.330596356797624, lng: 113.90682252296676 },
      },
      sizeInMeters: { width: 3396.349463445795, height: 3396.2989352503196 },
      lcBound: [
        [113.92682252065663, 22.312598035149605],
        [113.92666010018308, 22.313027721851515],
        [113.92747367244624, 22.313290920849102],
        [113.92763609228473, 22.31286123292018],
        [113.92682252065663, 22.312598035149605],
      ],
    },
    {
      id: "a497bbcc-682e-4353-9441-0cc1596c95dc",
      lcMapId: "c7495cbd-9647-47fe-a48c-1541373a5f24",
      lcMapName: "T1 Limousine Lounge L3-30",
      name: "T1_Level 3",
      ordinal: 3,
      shortName: "L3",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981080049_0fb0.png",
      pixInMeter: 3.0373540347515893,
      size: { width: 10322, height: 10322 },
      angle: 251.00332255258135,
      scale: 329.23393146824526,
      center: { lat: 22.32115857999625, lng: 113.92782097561258 },
      corners: {
        bl: { lat: 22.31168317647925, lng: 113.94881679103639 },
        br: { lat: 22.340582346885917, lng: 113.93806344901941 },
        tl: { lat: 22.30173639522843, lng: 113.91757933889323 },
        tr: { lat: 22.33063240139144, lng: 113.90682432350161 },
      },
      sizeInMeters: { width: 3398.2270814301187, height: 3398.1766412179018 },
      lcBound: [
        [113.93595045649784, 22.31390258984551],
        [113.93589313120003, 22.314054244045895],
        [113.93644260032988, 22.31423200130974],
        [113.93649992547614, 22.314080346816866],
        [113.93595045649784, 22.31390258984551],
      ],
    },
    {
      id: "a497bbcc-682e-4353-9441-0cc1596c95dc",
      lcMapId: "b3a6e885-4bed-48d7-a795-b6e50503a838",
      lcMapName: "L3 East Hall North & South-30",
      name: "T1_Level 3",
      ordinal: 3,
      shortName: "L3",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981080049_0fb0.png",
      pixInMeter: 3.0373540347515893,
      size: { width: 10322, height: 10322 },
      angle: 251.00332255258135,
      scale: 329.23393146824526,
      center: { lat: 22.32115857999625, lng: 113.92782097561258 },
      corners: {
        bl: { lat: 22.31168317647925, lng: 113.94881679103639 },
        br: { lat: 22.340582346885917, lng: 113.93806344901941 },
        tl: { lat: 22.30173639522843, lng: 113.91757933889323 },
        tr: { lat: 22.33063240139144, lng: 113.90682432350161 },
      },
      sizeInMeters: { width: 3398.2270814301187, height: 3398.1766412179018 },
      lcBound: [
        [113.93439519049991, 22.311873505569],
        [113.93206924566311, 22.31802672419599],
        [113.93355677885836, 22.318507961187095],
        [113.93588270706505, 22.312354710430114],
        [113.93439519049991, 22.311873505569],
      ],
    },
    {
      id: "ab270f31-f701-4b63-8d3c-103e816aa468",
      lcMapId: "9af91318-1bc0-4079-9a43-8103cfe385c0",
      lcMapName: "T1 Skybridge-50",
      name: "Skybridge_Level 5",
      ordinal: 5,
      shortName: "L5",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981022417_8276.png",
      pixInMeter: 3.126134206798896,
      size: { width: 10322, height: 10322 },
      angle: 250.95328279302137,
      scale: 319.88390241771566,
      center: { lat: 22.320974182254126, lng: 113.9279327941166 },
      corners: {
        bl: { lat: 22.311784381053286, lng: 113.94834101144716 },
        br: { lat: 22.339854337318013, lng: 113.9378665413708 },
        tl: { lat: 22.302095520262338, lng: 113.91799983344572 },
        tr: { lat: 22.330162490382865, lng: 113.90752379020273 },
      },
      sizeInMeters: { width: 3301.7232597208667, height: 3301.675549531018 },
      lcBound: [
        [113.93130287435645, 22.314307565202693],
        [113.93031018639317, 22.316933595984327],
        [113.93134771862128, 22.317269256290544],
        [113.93234040163429, 22.314643215944507],
        [113.93130287435645, 22.314307565202693],
      ],
    },
    {
      id: "b18bea58-db51-4d7b-a293-9752d2bb6336",
      lcMapId: "188ceb38-f2fb-4022-b39e-64fe6e8b600d",
      lcMapName: "MFC APM Plaform-10",
      name: "MFC_Level 1",
      ordinal: 1,
      shortName: "L1",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786982496323_ec2a.png",
      pixInMeter: 3.0539579092650824,
      size: { width: 10322, height: 10322 },
      angle: 251.06350579117003,
      scale: 327.44588275674124,
      center: { lat: 22.320995427088125, lng: 113.9276144562433 },
      corners: {
        bl: { lat: 22.311551034830256, lng: 113.9484860969178 },
        br: { lat: 22.340303168326837, lng: 113.93782297055077 },
        tl: { lat: 22.301687685849412, lng: 113.91740760509902 },
        tr: { lat: 22.330436688342292, lng: 113.9067428155688 },
      },
      sizeInMeters: { width: 3379.7519734301145, height: 3379.702197178159 },
      lcBound: [
        [113.91747970269557, 22.30946952750575],
        [113.91723979277162, 22.310104228235932],
        [113.91795317094943, 22.310335018658293],
        [113.91819308005108, 22.309700316339043],
        [113.91747970269557, 22.30946952750575],
      ],
    },
    {
      id: "b43c80e3-7d7a-42f7-ab70-9b39d56da20f",
      lcMapId: "0459770e-35cc-4eb3-8a67-da62c2833266",
      lcMapName: "L5_ITT-50",
      name: "Skypier_Level 5",
      ordinal: 5,
      shortName: "L5",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981022417_8276.png",
      pixInMeter: 3.0275230930690302,
      size: { width: 10322, height: 10322 },
      angle: 251.09632723639464,
      scale: 330.30301651085927,
      center: { lat: 22.321255377239474, lng: 113.92787437328434 },
      corners: {
        bl: { lat: 22.31171758431347, lng: 113.94892166910506 },
        br: { lat: 22.340726764652274, lng: 113.93818429667874 },
        tl: { lat: 22.30178558313553, lng: 113.9175652984502 },
        tr: { lat: 22.330791576856623, lng: 113.90682622890347 },
      },
      sizeInMeters: { width: 3409.2610722665145, height: 3409.2104922251565 },
      lcBound: [
        [113.9431432250285, 22.31636511991469],
        [113.94270733426856, 22.317518201283843],
        [113.94402813307534, 22.3179454963877],
        [113.94446402106814, 22.316792409671958],
        [113.9431432250285, 22.31636511991469],
      ],
    },
    {
      id: "b89ae8b7-e825-4ab1-afc3-7ff90f912520",
      lcMapId: "77c920d5-2349-421a-8e88-895c68ebb306",
      lcMapName: "T2 L5 M&G and Baggage Hall -50",
      name: "T2CoachHall_Level 5",
      ordinal: 5,
      shortName: "L5",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981022417_8276.png",
      pixInMeter: 3.0275507422982946,
      size: { width: 10322, height: 10322 },
      angle: 250.91296662126882,
      scale: 330.3,
      center: { lat: 22.32117644387052, lng: 113.92778090932211 },
      corners: {
        bl: { lat: 22.31170109778703, lng: 113.9488608921472 },
        br: { lat: 22.340678073277186, lng: 113.93802331646691 },
        tl: { lat: 22.301676405983113, lng: 113.91753933803716 },
        tr: { lat: 22.330650198434764, lng: 113.90670009063729 },
      },
      sizeInMeters: { width: 3409.2305050838713, height: 3409.1795550309494 },
      lcBound: [
        [113.93727092387837, 22.313310003648223],
        [113.93536487584333, 22.31835834982007],
        [113.93922658815848, 22.319606151488166],
        [113.94113260071606, 22.3145577368877],
        [113.93727092387837, 22.313310003648223],
      ],
    },
    {
      id: "bbb69bfc-7674-4600-b195-e37d7de4494b",
      lcMapId: "e470ab4c-dfc8-4bdb-9a55-27a9390fd143",
      lcMapName: "T1 AEL platform -50",
      name: "GTC_Level 5",
      ordinal: 5,
      shortName: "L5",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981022417_8276.png",
      pixInMeter: 3.0220701041300346,
      size: { width: 10322, height: 10322 },
      angle: 250.91296662126882,
      scale: 330.89901152556234,
      center: { lat: 22.32118094047234, lng: 113.92776632684252 },
      corners: {
        bl: { lat: 22.3116884090458, lng: 113.94888453893361 },
        br: { lat: 22.340717938265552, lng: 113.93802731007088 },
        tl: { lat: 22.301645539976516, lng: 113.91750618250865 },
        tr: { lat: 22.33067187460149, lng: 113.90664727585704 },
      },
      sizeInMeters: { width: 3415.4130441301086, height: 3415.3619090798384 },
      lcBound: [
        [113.93656673418775, 22.314479765591617],
        [113.93563381332933, 22.316947775731986],
        [113.93643853482615, 22.317208108405605],
        [113.93737145207604, 22.31474009129342],
        [113.93656673418775, 22.314479765591617],
      ],
    },
    {
      id: "be12cc27-dcff-461c-9dcf-15a9e7b3259c",
      lcMapId: "a19948cd-40f7-4203-92b6-0c1f1323bdee",
      lcMapName: "T1 GTC AEL & Floor interchange-60",
      name: "GTC_Level 6",
      ordinal: 6,
      shortName: "L6",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980969854_5f2c.png",
      pixInMeter: 3.0220517933800077,
      size: { width: 10322, height: 10322 },
      angle: 250.914649853275,
      scale: 330.9010164582007,
      center: { lat: 22.321177242519212, lng: 113.92776590739527 },
      corners: {
        bl: { lat: 22.311684079631494, lng: 113.94888394537679 },
        br: { lat: 22.340714079843124, lng: 113.9380275730058 },
        tl: { lat: 22.30164200252801, lng: 113.91750508080645 },
        tr: { lat: 22.330668808074225, lng: 113.90664703039226 },
      },
      sizeInMeters: { width: 3415.4337323152777, height: 3415.382600067979 },
      lcBound: [
        [113.93596896117276, 22.313449133787287],
        [113.93440110395159, 22.3175968364463],
        [113.93590977704093, 22.31808490604153],
        [113.93747762289252, 22.313937181416364],
        [113.93596896117276, 22.313449133787287],
      ],
    },
    {
      id: "d48aa7aa-3935-49c5-aaeb-ab5861e193fa",
      lcMapId: "6f139264-2bf0-4fc3-ad90-26d77a4534ea",
      lcMapName: "L4_Skypier & ITT-50",
      name: "Skypier_Level 4",
      ordinal: 4,
      shortName: "L4",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981051729_366f.jpg",
      pixInMeter: 3.027248141148277,
      size: { width: 10322, height: 10322 },
      angle: 251.01800377131647,
      scale: 330.3349848295656,
      center: { lat: 22.321239985889648, lng: 113.9278739516925 },
      corners: {
        bl: { lat: 22.311727728411505, lng: 113.94893795658254 },
        br: { lat: 22.340725643461113, lng: 113.93815582829632 },
        tl: { lat: 22.301754328318182, lng: 113.91759376146115 },
        tr: { lat: 22.330749057700853, lng: 113.90680994680247 },
      },
      sizeInMeters: { width: 3409.570956619355, height: 3409.5202051688793 },
      lcBound: [
        [113.94309734344881, 22.316492567238118],
        [113.94239031006612, 22.31836296394899],
        [113.94449110183916, 22.319042572643934],
        [113.94519812808187, 22.31717216213854],
        [113.94309734344881, 22.316492567238118],
      ],
    },
    {
      id: "dcbbdc73-ff0e-4417-980a-8a1ca875588c",
      lcMapId: "8efacc25-2e29-46d7-a1d9-553765394580",
      lcMapName: "L9 Skybridge-120",
      name: "Skybridge_Level 9",
      ordinal: 9,
      shortName: "L9",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1787117206791_db1f.jpg",
      pixInMeter: 3.126134206798896,
      size: { width: 10322, height: 10322 },
      angle: 250.95490853777028,
      scale: 319.8858521294204,
      center: { lat: 22.320974928790175, lng: 113.92793240082494 },
      corners: {
        bl: { lat: 22.311784381053286, lng: 113.94834101144716 },
        br: { lat: 22.339854337318013, lng: 113.9378665413708 },
        tl: { lat: 22.302095520262338, lng: 113.91799983344572 },
        tr: { lat: 22.330162490382865, lng: 113.90752379020273 },
      },
      sizeInMeters: { width: 3301.7232597208667, height: 3301.675549531018 },
      lcBound: [
        [113.93166697094546, 22.31519266167324],
        [113.93100772091827, 22.316936685952978],
        [113.93123844093452, 22.317011325006927],
        [113.93189769023058, 22.315267299314744],
        [113.93166697094546, 22.31519266167324],
      ],
    },
    {
      id: "dec31274-12a5-4113-addb-edff62922c21",
      lcMapId: "6cdc3838-9ee3-41f9-bac7-b06d07ad6626",
      lcMapName: "T1L6 Skybridge-60",
      name: "Skybridge_Level 6",
      ordinal: 6,
      shortName: "L6",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980969854_5f2c.png",
      pixInMeter: 3.126115152938268,
      size: { width: 10322, height: 10322 },
      angle: 250.95490853777028,
      scale: 319.8858521294204,
      center: { lat: 22.320974928790175, lng: 113.92793726164427 },
      corners: {
        bl: { lat: 22.311784535869872, lng: 113.94834532155335 },
        br: { lat: 22.33985493819668, lng: 113.93787164863932 },
        tl: { lat: 22.302096412488652, lng: 113.91800366134771 },
        tr: { lat: 22.330163828605514, lng: 113.90752841503684 },
      },
      sizeInMeters: { width: 3301.7433784798845, height: 3301.6956707914974 },
      lcBound: [
        [113.93131415003245, 22.31438935967915],
        [113.93032262109182, 22.317012413874036],
        [113.93126067917876, 22.3173158820013],
        [113.93225220364877, 22.314692819168894],
        [113.93131415003245, 22.31438935967915],
      ],
    },
    {
      id: "e1c8542e-98f5-4d36-bffb-4d926419e0be",
      lcMapId: "9eaf6d0c-f592-441b-8f74-3c0e731a9f53",
      lcMapName: "T1 - Skybridge",
      name: "Skybridge_Level 7",
      ordinal: 7,
      shortName: "L7",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980626177_4d57.png",
      pixInMeter: 3.126134206798896,
      size: { width: 10322, height: 10322 },
      angle: 250.95490853777028,
      scale: 319.8858521294204,
      center: { lat: 22.320974928790175, lng: 113.92793240082494 },
      corners: {
        bl: { lat: 22.311784381053286, lng: 113.94834101144716 },
        br: { lat: 22.339854337318013, lng: 113.9378665413708 },
        tl: { lat: 22.302095520262338, lng: 113.91799983344572 },
        tr: { lat: 22.330162490382865, lng: 113.90752379020273 },
      },
      sizeInMeters: { width: 3301.7232597208667, height: 3301.675549531018 },
      lcBound: [
        [113.93135581793445, 22.31437860021001],
        [113.9303696467191, 22.316991048876265],
        [113.93135848793679, 22.317310508723065],
        [113.93234465445005, 22.3146980509898],
        [113.93135581793445, 22.31437860021001],
      ],
    },
    {
      id: "e48ad7cb-51b1-4a9e-bafb-25badb6ec6e3",
      lcMapId: "98efb970-55e4-49c2-8691-aa4fc3364538",
      lcMapName: "T1 Checkin hall -70",
      name: "T1_Level 7",
      ordinal: 7,
      shortName: "L7",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980626177_4d57.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.93515238110353, 22.313017703774456],
        [113.93337970114885, 22.31771366759506],
        [113.93524571873877, 22.318316518747316],
        [113.93701838274433, 22.31362052417104],
        [113.93515238110353, 22.313017703774456],
      ],
    },
    {
      id: "e48ad7cb-51b1-4a9e-bafb-25badb6ec6e3",
      lcMapId: "667ff337-140e-45af-bf3d-3a750bf89aee",
      lcMapName: "T1 East Hall-70",
      name: "T1_Level 7",
      ordinal: 7,
      shortName: "L7",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980626177_4d57.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.93354814656698, 22.31315734615913],
        [113.93233687313261, 22.316361737575924],
        [113.93389422314203, 22.316865555181753],
        [113.93510548750976, 22.31366114624755],
        [113.93354814656698, 22.31315734615913],
      ],
    },
    {
      id: "e48ad7cb-51b1-4a9e-bafb-25badb6ec6e3",
      lcMapId: "0ed21021-c0cb-47b3-a163-77135df6dcbe",
      lcMapName: "T1 - West Hall",
      name: "T1_Level 7",
      ordinal: 7,
      shortName: "L7",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980626177_4d57.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.92657721349849, 22.311827113888654],
        [113.92595389577184, 22.313475592200128],
        [113.9273897418966, 22.31394025191763],
        [113.92801305532498, 22.312291765297964],
        [113.92657721349849, 22.311827113888654],
      ],
    },
    {
      id: "e6031da7-08fc-4db7-9ac0-2b8f138deaf1",
      lcMapId: "4eb0a0ed-f244-4e57-828d-7671fd44c578",
      lcMapName: "T2 L8 Departure Kerb -80",
      name: "T2CoachHall_Level 8",
      ordinal: 8,
      shortName: "L8",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786979684092_7659.png",
      pixInMeter: 3.022070104143553,
      size: { width: 10322, height: 10322 },
      angle: 250.96296662126878,
      scale: 330.89901152556234,
      center: { lat: 22.32119712823889, lng: 113.92777021550285 },
      corners: {
        bl: { lat: 22.31168755163711, lng: 113.94887946623396 },
        br: { lat: 22.340725835736112, lng: 113.93804962723539 },
        tl: { lat: 22.30167001852208, lng: 113.91749164614134 },
        tr: { lat: 22.33070510706024, lng: 113.90666012240081 },
      },
      sizeInMeters: { width: 3415.4128890695874, height: 3415.361855304897 },
      lcBound: [
        [113.93731135579026, 22.313174353916885],
        [113.93539807546028, 22.318238651162158],
        [113.93927198613414, 22.319491188673343],
        [113.94118523079146, 22.314426822562023],
        [113.93731135579026, 22.313174353916885],
      ],
    },
    {
      id: "ea34f754-4fb9-418e-99ac-05130f1d8e23",
      lcMapId: "d0299b1c-f4d9-46c4-9392-7774988c7a66",
      lcMapName: "T2 Coach Hall -30",
      name: "GTC_Level 3",
      ordinal: 3,
      shortName: "L3",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981080049_0fb0.png",
      pixInMeter: 3.050417978336127,
      size: { width: 10322, height: 10322 },
      angle: 251.00332062210026,
      scale: 327.8239300771842,
      center: { lat: 22.321136095167198, lng: 113.92785500236016 },
      corners: {
        bl: { lat: 22.311701275732275, lng: 113.94876089832428 },
        br: { lat: 22.340476673353336, lng: 113.93805360646365 },
        tl: { lat: 22.301797085578716, lng: 113.91765722779166 },
        tr: { lat: 22.330569346004435, lng: 113.90694827686104 },
      },
      sizeInMeters: { width: 3383.674120650329, height: 3383.6241116435103 },
      lcBound: [
        [113.93714328853662, 22.313453933176262],
        [113.93532175587507, 22.31826424617908],
        [113.93899347147476, 22.319454154484244],
        [113.94081497211698, 22.314643779467293],
        [113.93714328853662, 22.313453933176262],
      ],
    },
    {
      id: "f200bad8-65c5-4ce2-ae8e-030bf3c00134",
      lcMapId: "2a85f16c-78fd-4d04-a1ff-f51de23d8706",
      lcMapName: "T2 L7 Check-in Hall -70",
      name: "T2CoachHall_Level 7",
      ordinal: 7,
      shortName: "L7",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980626177_4d57.png",
      pixInMeter: 3.0220884201556406,
      size: { width: 10322, height: 10322 },
      angle: 250.91296662126882,
      scale: 330.89901152556234,
      center: { lat: 22.32118094047234, lng: 113.9277566051893 },
      corners: {
        bl: { lat: 22.311688241911124, lng: 113.94887541004528 },
        br: { lat: 22.34071730005955, lng: 113.93801732505074 },
        tl: { lat: 22.301644580885124, lng: 113.91749756286231 },
        tr: { lat: 22.330670444510044, lng: 113.90663780033333 },
      },
      sizeInMeters: { width: 3415.392350265988, height: 3415.341212434632 },
      lcBound: [
        [113.93726582579154, 22.31330674555455],
        [113.93536935039958, 22.318368184907623],
        [113.93924107856253, 22.319609719895436],
        [113.94113751794464, 22.314548211814877],
        [113.93726582579154, 22.31330674555455],
      ],
    },
    {
      id: "f66fedce-16fb-4916-b79b-25f41f11ed28",
      lcMapId: "e54e0482-247a-4edf-8e31-d3330c2e0698",
      lcMapName: "MFC L4_APV gate area & Floor interchange-40",
      name: "MFC_Level 4",
      ordinal: 4,
      shortName: "L4",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981051729_366f.jpg",
      pixInMeter: 3.0539579092650824,
      size: { width: 10322, height: 10322 },
      angle: 251.06350579117003,
      scale: 327.44588275674124,
      center: { lat: 22.320995427088125, lng: 113.9276144562433 },
      corners: {
        bl: { lat: 22.311551034830256, lng: 113.9484860969178 },
        br: { lat: 22.340303168326837, lng: 113.93782297055077 },
        tl: { lat: 22.301687685849412, lng: 113.91740760509902 },
        tr: { lat: 22.330436688342292, lng: 113.9067428155688 },
      },
      sizeInMeters: { width: 3379.7519734301145, height: 3379.702197178159 },
      lcBound: [
        [113.91819981405513, 22.30660993797968],
        [113.9156627011696, 22.313322026749876],
        [113.91738392947059, 22.313878888380113],
        [113.91992102137101, 22.307166759064156],
        [113.91819981405513, 22.30660993797968],
      ],
    },
    {
      id: "f860e259-83ad-4f3a-a004-9ae3e1f6c588",
      lcMapId: "131859e9-92af-4e9c-a0c1-1006426d6e17",
      lcMapName: "MFC North-60",
      name: "MFC_Level 6",
      ordinal: 6,
      shortName: "L6",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980969854_5f2c.png",
      pixInMeter: 3.0539579092650824,
      size: { width: 10322, height: 10322 },
      angle: 251.06350579117003,
      scale: 327.44588275674124,
      center: { lat: 22.320995427088125, lng: 113.9276144562433 },
      corners: {
        bl: { lat: 22.311551034830256, lng: 113.9484860969178 },
        br: { lat: 22.340303168326837, lng: 113.93782297055077 },
        tl: { lat: 22.301687685849412, lng: 113.91740760509902 },
        tr: { lat: 22.330436688342292, lng: 113.9067428155688 },
      },
      sizeInMeters: { width: 3379.7519734301145, height: 3379.702197178159 },
      lcBound: [
        [113.91717107776833, 22.30946772365427],
        [113.91581015523161, 22.31306810158658],
        [113.91717014635492, 22.313508083597355],
        [113.91853105999712, 22.309907688479793],
        [113.91717107776833, 22.30946772365427],
      ],
    },
    {
      id: "f860e259-83ad-4f3a-a004-9ae3e1f6c588",
      lcMapId: "9024e86e-7fd8-4d6e-88c0-64027284ca15",
      lcMapName: "MFC South-60",
      name: "MFC_Level 6",
      ordinal: 6,
      shortName: "L6",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786980969854_5f2c.png",
      pixInMeter: 3.0539579092650824,
      size: { width: 10322, height: 10322 },
      angle: 251.06350579117003,
      scale: 327.44588275674124,
      center: { lat: 22.320995427088125, lng: 113.9276144562433 },
      corners: {
        bl: { lat: 22.311551034830256, lng: 113.9484860969178 },
        br: { lat: 22.340303168326837, lng: 113.93782297055077 },
        tl: { lat: 22.301687685849412, lng: 113.91740760509902 },
        tr: { lat: 22.330436688342292, lng: 113.9067428155688 },
      },
      sizeInMeters: { width: 3379.7519734301145, height: 3379.702197178159 },
      lcBound: [
        [113.91820723542071, 22.306728585184896],
        [113.91699920322662, 22.30992455244157],
        [113.91836827210477, 22.310367479787683],
        [113.91957629635158, 22.30717149717623],
        [113.91820723542071, 22.306728585184896],
      ],
    },
    {
      id: "fa0f596e-d6fd-4171-9dd6-9187863f4517",
      lcMapId: "95f01a90-c388-47bd-8941-d2f58aad6c16",
      lcMapName: "NSC-50",
      name: "NSC_Level 5",
      ordinal: 5,
      shortName: "L5",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981022417_8276.png",
      pixInMeter: 3.121371766874,
      size: { width: 10322, height: 10322 },
      angle: 251.00328279302133,
      scale: 320.3739024177152,
      center: { lat: 22.320978678855937, lng: 113.9279327941162 },
      corners: {
        bl: { lat: 22.311758145414913, lng: 113.94836413718997 },
        br: { lat: 22.3398791160007, lng: 113.93789934958181 },
        tl: { lat: 22.302078241711175, lng: 113.91796782292033 },
        tr: { lat: 22.330196216161063, lng: 113.90750145104244 },
      },
      sizeInMeters: { width: 3306.7605498690205, height: 3306.7127859951647 },
      lcBound: [
        [113.92987692263932, 22.316530140451928],
        [113.9293803634846, 22.31784370957962],
        [113.93052330832086, 22.318213466371166],
        [113.93101986474767, 22.316899891972884],
        [113.92987692263932, 22.316530140451928],
      ],
    },
    {
      id: "fdf422f6-2805-4865-a6c3-1c2f856651c1",
      lcMapId: "3815a361-f899-4f0c-af3c-d4150b37a58a",
      lcMapName: "T1 Lim, M&G, CP4E - 50",
      name: "T1_Level 5",
      ordinal: 5,
      shortName: "L5",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981022417_8276.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.93517810540243, 22.313249188071577],
        [113.9332740211014, 22.318286346680136],
        [113.93516774825332, 22.318898985913602],
        [113.93707181522245, 22.313861793819385],
        [113.93517810540243, 22.313249188071577],
      ],
    },
    {
      id: "fdf422f6-2805-4865-a6c3-1c2f856651c1",
      lcMapId: "9f77ade5-aae8-4752-8753-a48dcc9cb402",
      lcMapName: "L5 Baggage Reclaim Hall-50",
      name: "T1_Level 5",
      ordinal: 5,
      shortName: "L5",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981022417_8276.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.93506481521047, 22.31383963554133],
        [113.93382654284983, 22.317115446763506],
        [113.93471107096923, 22.31740159890393],
        [113.93594933806526, 22.31412577751042],
        [113.93506481521047, 22.31383963554133],
      ],
    },
    {
      id: "fdf422f6-2805-4865-a6c3-1c2f856651c1",
      lcMapId: "13512d1f-d3c7-4eaf-a3ff-c5db7cb4d702",
      lcMapName: "T1  SC, NC & East Hall-50",
      name: "T1_Level 5",
      ordinal: 5,
      shortName: "L5",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981022417_8276.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.93413564128116, 22.311800871287268],
        [113.9318376025816, 22.317880055167326],
        [113.93354274802493, 22.318431711596332],
        [113.93584076789193, 22.312352491329264],
        [113.93413564128116, 22.311800871287268],
      ],
    },
    {
      id: "fdf422f6-2805-4865-a6c3-1c2f856651c1",
      lcMapId: "01f85c32-4fd0-48f5-9a8f-ef2b5ef338d9",
      lcMapName: "T1 Central Concourse-50",
      name: "T1_Level 5",
      ordinal: 5,
      shortName: "L5",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981022417_8276.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.92758571544118, 22.31239806906267],
        [113.92713013956245, 22.31360322892136],
        [113.93304923396465, 22.31551817506262],
        [113.933504796884, 22.314312990164527],
        [113.92758571544118, 22.31239806906267],
      ],
    },
    {
      id: "fdf422f6-2805-4865-a6c3-1c2f856651c1",
      lcMapId: "e5bd679e-5cdc-4f28-beef-1688d42bd06e",
      lcMapName: "T1 SouthWest Concourse-50",
      name: "T1_Level 5",
      ordinal: 5,
      shortName: "L5",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981022417_8276.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.9252149689521, 22.3091845975201],
        [113.92409138133542, 22.312156973873346],
        [113.92755505680793, 22.313277573413703],
        [113.9286786257237, 22.310305160926813],
        [113.9252149689521, 22.3091845975201],
      ],
    },
    {
      id: "fdf422f6-2805-4865-a6c3-1c2f856651c1",
      lcMapId: "99d68128-5598-42e2-875b-c6cd8fa692a0",
      lcMapName: "T1  NorthWest Concourse-50",
      name: "T1_Level 5",
      ordinal: 5,
      shortName: "L5",
      imageUrl:
        "https://gis-dev.locaite.com/assets/b4ed5551-8356-4b38-ae30-6b6b30d094f4/map/1786981022417_8276.png",
      pixInMeter: 3.039051846542454,
      size: { width: 10322, height: 10322 },
      angle: 250.93167319620747,
      scale: 329.0519922696148,
      center: { lat: 22.32115654933058, lng: 113.92782035274075 },
      corners: {
        bl: { lat: 22.31171050018254, lng: 113.94881793867512 },
        br: { lat: 22.340580776401733, lng: 113.93803065377188 },
        tl: { lat: 22.30173232225943, lng: 113.91761171314079 },
        tr: { lat: 22.330599439164946, lng: 113.90682276680639 },
      },
      sizeInMeters: { width: 3396.32890585421, height: 3396.278374912276 },
      lcBound: [
        [113.9241274170032, 22.311628929544],
        [113.9228732978504, 22.31494655394357],
        [113.92646532659035, 22.31610865934958],
        [113.92771942409377, 22.312790993120128],
        [113.9241274170032, 22.311628929544],
      ],
    },
  ],
  modelConfig: {
    folderPath: "venue/hkia/",
    defaultPosition: [-2485, 146, -7690],
    defaultTarget: [-2485, 146, -7695],
    defaultLcMapId: "2a85f16c-78fd-4d04-a1ff-f51de23d8706",
    topAltitude: 1000,
    downSpeed: 200,
    scaleFactor: 8.82037483065,
    moveSpeed: 2,
    rotateSpeed: 20,
    splat: {
      mode: "floorLod",
    },
    floor: [
      {
        //////////////////
        id: "0590e405-25f5-4cae-ba42-90e92ec04153",
        lcMapId: "ebbac3b3-6c85-497a-b1ea-3003d5954e83",
        name: "T1 Bus Station & Carpark1 Coach bay -30",
        shortName: "L3",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L3_20260824_1530.glb",
        isNotReady: true,
      },
      {
        id: "07a7b6c2-0a22-4e23-89a8-679a7f38070b",
        lcMapId: "0bdb2c4b-3c65-44dd-a45e-35b28fa98179",
        name: "Skypier L1 APM Platform",
        shortName: "L1",
        yAxis: 20,
        altitude: 30,
        defaultPosition: [-2625, 30, -9280],
        defaultTarget: [-2625, 30, -9285],
        topViewModel:
          "Skypier_L1_APM_Platform/top_view/Skypier_L1_APM_Platform_top_view_20260828_1700_64tiles.glb",
        meshGround:
          "Skypier_L1_APM_Platform/mesh_ground/Skypier_L1_APM_Platform_mesh_ground_20260903_1000.glb",
        lod: "Skypier_L1_APM_Platform/splat/Sky_Pier_L1_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["0bdb2c4b-3c65-44dd-a45e-35b28fa98179"],
      },
      {
        id: "07ed256f-fd6a-4d75-87a6-6545733d29ca",
        lcMapId: "049d1110-ef7b-4273-8d0e-7bc3aff284b2",
        name: "T1 L7 MFC",
        shortName: "L7",
        yAxis: 140,
        altitude: 150,
        defaultPosition: [-2613, 10, -1093],
        defaultTarget: [-2608, 10, -1093],
        topViewModel:
          "T1_L7_MFC/top_view/T1_L7_MFC_top_view_20260827_1300_64tiles.glb",
        meshGround:
          "T1_L7_MFC/mesh_ground/T1_L7_MFC_mesh_ground_20260827_1120_c.glb",
        lod: "T1_L7_MFC/splat/T1_L7_MFC_v2_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["049d1110-ef7b-4273-8d0e-7bc3aff284b2"],
      },
      {
        id: "15b1dfeb-efcf-4f0a-bd29-0cc6d2fa363d",
        lcMapId: "3ac50d06-fad6-4138-bc28-153322583a00",
        name: "T1 L4 NSC & Skybridge",
        shortName: "L4",
        yAxis: 80,
        altitude: 90,
        defaultPosition: [-3750, 90, -5386],
        defaultTarget: [-3745, 90, -5386],
        topViewModel:
          "T1_L4_NSC_Skybridge/top_view/T1_L4_NSC_Skybridge_top_view_20260907_1200_64tiles.glb",
        meshGround:
          "T1_L4_NSC_Skybridge/mesh_ground/T1_L4_NSC_Skybridge_mesh_ground_20260907_1200_c.glb",
        lod: "T1_L4_NSC_Skybridge/splat/T1_L4_NSC_Skybridge_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["3ac50d06-fad6-4138-bc28-153322583a00"],
      },
      {
        id: "1cefdb09-17d9-4f29-bc20-d3b5a26e5462",
        lcMapId: "0afc009c-3f6c-4f0b-b94e-f1b791e5f9a5",
        name: "T2 L6 AEL Departure",
        shortName: "L6",
        yAxis: 120,
        altitude: 130,
        defaultPosition: [-2790, 130, -7185],
        defaultTarget: [-2785, 130, -7185],
        topViewModel:
          "T2_L6_AEL_Departure/top_view/T2_L6_AEL_Departure_top_view_20260824_1445_64tiles.glb",
        meshGround:
          "T2_L6_AEL_Departure/mesh_ground/T2_L6_AEL_Departure_mesh_ground_20260826_2330_c.glb",
        lod: "T2_L6_AEL_Departure/splat/HKIA_T2_L6_AEL_Departure_v3_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["0afc009c-3f6c-4f0b-b94e-f1b791e5f9a5"],
      },
      {
        ////////////
        id: "2d339cdd-32ed-46d4-90e1-6127cc08a9c2",
        lcMapId: "960dbfd1-15e1-445b-a1a9-35271aa17537",
        name: "T2 L1 APM Platform -10",
        shortName: "L1",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L1_20260824_1530.glb",
        isNotReady: true,
      },
      {
        /////////////
        id: "2edf4f0b-d447-4e86-943a-ac18ad124a69",
        lcMapId: "642cd35f-a687-4697-a3ef-3e217ccb22f6",
        name: "T2 L2 Transfer Area -20",
        shortName: "L2",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L2_20260824_1530.glb",
        isNotReady: true,
      },
      {
        /////////////////
        id: "45fb80c6-e13e-48c5-a431-0a1d33d20909",
        lcMapId: "06de22a6-3392-405b-b93d-60709e1019cc",
        name: "T2 L3 Immigration Hall -30",
        shortName: "L3",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L3_20260824_1530.glb",
        isNotReady: true,
      },
      {
        /////////////
        id: "466904b6-b658-4a56-b70f-ff508c93a531",
        lcMapId: "603c72ff-b2cb-4c2b-ad70-1e116dacf9c4",
        name: "T1 Link Bridge to Carpark4 L3-30",
        shortName: "L3",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L3_20260824_1530.glb",
        isNotReady: true,
      },
      {
        id: "52e0677d-4fec-482d-8b25-d23c6fa3d25a",
        lcMapId: "02746beb-f403-42c9-a68c-d14442872a5a",
        name: "T1 L1 APM Platform East",
        shortName: "L1",
        yAxis: 20,
        altitude: 30,
        defaultPosition: [-2554, 30, -6109],
        defaultTarget: [-2554, 30, -6114],
        topViewModel:
          "T1_L1_APM_Platform_East/top_view/T1_L1_APM_Platform_East_top_view_20260907_1800_64tiles.glb",
        meshGround:
          "T1_L1_APM_Platform_East/mesh_ground/T1_L1_APM_Platform_East_mesh_ground_20260907_1855_c.glb",
        lod: "T1_L1_APM_Platform_East/splat/T1_L1_APM_Platform_East_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["02746beb-f403-42c9-a68c-d14442872a5a"],
      },
      {
        id: "52e0677d-4fec-482d-8b25-d23c6fa3d25a",
        lcMapId: "e9052fa6-2005-4b54-b4b1-28eaa6f41d9d",
        name: "T1 L1 APM Platform West",
        shortName: "L1",
        yAxis: 20,
        altitude: 30,
        defaultPosition: [-2572, 30, -4013],
        defaultTarget: [-2572, 30, -4018],
        topViewModel:
          "T1_L1_APM_Platform_West/top_view/T1_L1_APM_Platform_West_top_view_20260907_2200.glb",
        meshGround:
          "T1_L1_APM_Platform_West/mesh_ground/T1_L1_APM_Platform_West_mesh_ground_20260907_2230_c.glb",
        lod: "T1_L1_APM_Platform_West/splat/T1_L1_APM_Platform_West_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["e9052fa6-2005-4b54-b4b1-28eaa6f41d9d"],
      },
      {
        ////////////////
        id: "5c11661d-b37c-4353-8599-58d823066ce5",
        lcMapId: "72eefd8c-eb60-4929-8f16-adff1bf98451",
        name: "L8 Restaurant-80",
        shortName: "L8",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L8_20260824_1530.glb",
        isNotReady: true,
      },
      {
        //////////////
        id: "5c11661d-b37c-4353-8599-58d823066ce5",
        lcMapId: "7f3d0703-3780-420e-859c-826908ad4d88",
        name: "L8 Bus Kerb-80",
        shortName: "L8",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L8_20260824_1530.glb",
        isNotReady: true,
      },
      {
        id: "5d7831ee-e7f0-49ce-872a-a9cecf385e6e",
        lcMapId: "09c06847-2f22-4d79-b582-b0382c2cdbd3",
        name: "Skypier L3 ITT",
        shortName: "L3",
        yAxis: 60,
        altitude: 70,
        defaultPosition: [-2299, 70, -9340],
        defaultTarget: [-2296, 70, -9344],
        topViewModel:
          "Skypier_L3_ITT/top_view/Skypier_L3_ITT_top_view_20260828_1700_64tiles.glb",
        meshGround:
          "Skypier_L3_ITT/mesh_ground/Skypier_L3_ITT_mesh_ground_20260902_1930_c.glb",
        lod: "Skypier_L3_ITT/splat/Skypier_L3_ITT_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["09c06847-2f22-4d79-b582-b0382c2cdbd3"],
      },
      {
        ////////
        id: "7b1ba8cf-6c71-4e6e-a2e8-e63145b3be74",
        lcMapId: "b54a4b38-be61-4d19-9880-c6ee19fa60c3",
        name: "MFC North-50",
        shortName: "L5",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L5_20260824_1530.glb",
        isNotReady: true,
      },
      {
        /////////
        id: "7b1ba8cf-6c71-4e6e-a2e8-e63145b3be74",
        lcMapId: "a614eb56-a7d6-4961-9433-95621a8474ab",
        name: "MFC South-50",
        shortName: "L5",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L5_20260824_1530.glb",
        isNotReady: true,
      },
      {
        id: "7c876b65-120b-43d6-a6b4-393336d7aed8",
        lcMapId: "482f719a-ddf9-40f0-816e-9adc36651530",
        name: "T1 L6 SouthConcourse NorthConcourse East Hall",
        shortName: "L6",
        yAxis: 120,
        altitude: 130,
        defaultPosition: [-2598, 130, -6112],
        defaultTarget: [-2598, 130, -6117],
        topViewModel:
          "T1_L6_SouthConcourse_NorthConcourse_East_Hall/top_view/T1_L6_SouthConcourse_NorthConcourse_East_Hall_top_view_20260901_1600_64tiles.glb",
        meshGround:
          "T1_L6_SouthConcourse_NorthConcourse_East_Hall/mesh_ground/T1_L6_SouthConcourse_NorthConcourse_East_Hall_mesh_ground_20260901_1730_c.glb",
        lod: "T1_L6_SouthConcourse_NorthConcourse_East_Hall/splat/T1_L6_SouthConcourse_NorthConcourse_East_Hall_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["482f719a-ddf9-40f0-816e-9adc36651530"],
      },
      {
        //////////////
        id: "7c876b65-120b-43d6-a6b4-393336d7aed8",
        lcMapId: "1ded34ae-ad26-467b-a1aa-47571c7e296a",
        name: "T1 Central Concourse-60",
        shortName: "L6",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L6_20260824_1530.glb",
        isNotReady: true,
      },
      {
        /////////////
        id: "7c876b65-120b-43d6-a6b4-393336d7aed8",
        lcMapId: "dd39c61e-5789-4ec3-8f5e-d71c51fe7ffd",
        name: "T1 NorthWest Concourse-60",
        shortName: "L6",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L6_20260824_1530.glb",
        isNotReady: true,
      },
      {
        //////////////
        id: "7c876b65-120b-43d6-a6b4-393336d7aed8",
        lcMapId: "4df431eb-44fa-449d-8786-6675e2dc8146",
        name: "T1 SouthWest Concourse-60",
        shortName: "L6",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L6_20260824_1530.glb",
        isNotReady: true,
      },
      {
        //////////////
        id: "7c876b65-120b-43d6-a6b4-393336d7aed8",
        lcMapId: "6e1c2815-836c-41a7-82b8-a317a6f2eed1",
        name: "T1 West Hall-60",
        shortName: "L6",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L6_20260824_1530.glb",
        isNotReady: true,
      },
      {
        id: "805966d3-e4ad-433b-87cd-47a689a83f8f",
        lcMapId: "781d3ab3-867c-4841-8b5e-010f3add87d2",
        name: "T1 L4 APV Floor",
        shortName: "L4",
        yAxis: 80,
        altitude: 90,
        defaultPosition: [-2594, 90, -6247],
        defaultTarget: [-2594, 90, -6252],
        topViewModel:
          "T1_L4_APV_Floor/top_view/T1_L4_APV_Floor_top_view_20260901_1600_64tiles.glb",
        meshGround:
          "T1_L4_APV_Floor/mesh_ground/T1_L4_APV_Floor_mesh_ground_20260901_1930_c.glb",
        lod: "T1_L4_APV_Floor/splat/T1_L4_APV_Floor_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["781d3ab3-867c-4841-8b5e-010f3add87d2"],
      },
      {
        /////////////
        id: "805966d3-e4ad-433b-87cd-47a689a83f8f",
        lcMapId: "e6919554-92f3-4188-9c18-76a682ba001f",
        name: "T1 L4_Floor interchange(west)-40",
        shortName: "L4",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L4_20260824_1530.glb",
        isNotReady: true,
      },
      {
        //////////
        id: "a497bbcc-682e-4353-9441-0cc1596c95dc",
        lcMapId: "c7495cbd-9647-47fe-a48c-1541373a5f24",
        name: "T1 Limousine Lounge L3-30",
        shortName: "L3",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L3_20260824_1530.glb",
        isNotReady: true,
      },
      {
        ////////////
        id: "a497bbcc-682e-4353-9441-0cc1596c95dc",
        lcMapId: "b3a6e885-4bed-48d7-a795-b6e50503a838",
        name: "L3 East Hall North & South-30",
        shortName: "L3",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L3_20260824_1530.glb",
        isNotReady: true,
      },
      {
        ///////////
        id: "ab270f31-f701-4b63-8d3c-103e816aa468",
        lcMapId: "9af91318-1bc0-4079-9a43-8103cfe385c0",
        name: "T1 Skybridge-50",
        shortName: "L5",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L5_20260824_1530.glb",
        isNotReady: true,
      },
      {
        id: "b18bea58-db51-4d7b-a293-9752d2bb6336",
        lcMapId: "188ceb38-f2fb-4022-b39e-64fe6e8b600d",
        name: "T1 L1 MFC APM Plaform",
        shortName: "L1",
        yAxis: 20,
        altitude: 30,
        defaultPosition: [-2571, 30, -950],
        defaultTarget: [-2571, 30, -945],
        topViewModel:
          "T1_L1_MFC_APM_Plaform/top_view/T1_L1_MFC_APM_Plaform_top_view_20260908_1130_64tiles.glb",
        meshGround:
          "T1_L1_MFC_APM_Plaform/mesh_ground/T1_L1_MFC_APM_Plaform_mesh_ground_20260908_1130_c.glb",
        lod: "T1_L1_MFC_APM_Plaform/splat/T1_L1_MFC_APM_Plaform_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["188ceb38-f2fb-4022-b39e-64fe6e8b600d"],
      },
      {
        id: "b43c80e3-7d7a-42f7-ab70-9b39d56da20f",
        lcMapId: "0459770e-35cc-4eb3-8a67-da62c2833266",
        name: "Skypier L5 ITT",
        shortName: "L5",
        yAxis: 100,
        altitude: 110,
        defaultPosition: [-2264, 110, -9268],
        defaultTarget: [-2262, 110, -9272],
        topViewModel:
          "Skypier_L5_ITT/top_view/Skypier_L5_ITT_top_view_20260903_1150_64tiles.glb",
        meshGround:
          "Skypier_L5_ITT/mesh_ground/Skypier_L5_ITT_mesh_ground_20260903_1200_c.glb",
        lod: "Skypier_L5_ITT/splat/Skypier_L5_ITT_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["0459770e-35cc-4eb3-8a67-da62c2833266"],
      },
      {
        id: "b89ae8b7-e825-4ab1-afc3-7ff90f912520",
        lcMapId: "77c920d5-2349-421a-8e88-895c68ebb306",
        index: 5,
        name: "T2 L5 M&G and Baggage Hall",
        shortName: "L5",
        yAxis: 100,
        altitude: 110,
        defaultPosition: [-2430, 110, -7560],
        defaultTarget: [-2430, 110, -7565],
        topViewModel:
          "T2_L5_MG_Baggage_Hall/top_view/T2_L5_mg_baggage_hall_with_mtr_top_view_20260824_1447_64tiles.glb",
        meshGround:
          "T2_L5_MG_Baggage_Hall/mesh_ground/T2_L5_MG_Baggage_Hall_With_Mtr_mesh_ground_20260826_2300_c.glb",
        lod: "T2_L5_MG_Baggage_Hall/splat/HKIA_T2_L5_MG_Baggage_Hall_with_MTR_v4_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["77c920d5-2349-421a-8e88-895c68ebb306"],
      },
      {
        id: "bbb69bfc-7674-4600-b195-e37d7de4494b",
        lcMapId: "e470ab4c-dfc8-4bdb-9a55-27a9390fd143",
        name: "T1 L5 AEL Platform",
        shortName: "L5",
        yAxis: 100,
        altitude: 107,
        defaultPosition: [-2585, 107, -7090],
        defaultTarget: [-2585, 107, -7095],
        topViewModel:
          "T1_L5_AEL_Platform/top_view/T1_L5_AEL_platform_top_view_20260824_1450_64tiles.glb",
        meshGround:
          "T1_L5_AEL_Platform/mesh_ground/T1_L5_AEL_Platform_mesh_ground_20260826_2355_c.glb",
        lod: "T1_L5_AEL_Platform/splat/T1_L5_AEL_platform_v4_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["e470ab4c-dfc8-4bdb-9a55-27a9390fd143"],
      },
      {
        id: "be12cc27-dcff-461c-9dcf-15a9e7b3259c",
        lcMapId: "a19948cd-40f7-4203-92b6-0c1f1323bdee",
        name: "T1 L6 GTC AEL & Floor Interchange",
        shortName: "L6",
        yAxis: 120,
        altitude: 130,
        defaultPosition: [-2571, 130, -7136],
        defaultTarget: [-2576, 130, -7138],
        topViewModel:
          "T1_L6_GTC_AEL_Floor_Interchange/top_view/T1_L6_GTC_AEL_Floor_Interchange_top_view_20260828_0200_64tiles.glb",
        meshGround:
          "T1_L6_GTC_AEL_Floor_Interchange/mesh_ground/T1_L6_GTC_AEL_Floor_Interchange_mesh_ground_20260828_1540_c.glb",
        lod: "T1_L6_GTC_AEL_Floor_Interchange/splat/T1_L6_GTC_AEL_Floor_Interchange_v2_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["a19948cd-40f7-4203-92b6-0c1f1323bdee"],
      },
      {
        id: "d48aa7aa-3935-49c5-aaeb-ab5861e193fa",
        lcMapId: "6f139264-2bf0-4fc3-ad90-26d77a4534ea",
        name: "Skypier L4 ITT",
        shortName: "L4",
        yAxis: 80,
        altitude: 90,
        defaultPosition: [-2273, 90, -9403],
        defaultTarget: [-2278, 90, -9405],
        topViewModel:
          "Skypier_L4_ITT/top_view/Skypier_L4_ITT_top_view_20260903_1730_64tiles.glb",
        meshGround:
          "Skypier_L4_ITT/mesh_ground/Skypier_L4_ITT_mesh_ground_20260903_1800_c.glb",
        lod: "Skypier_L4_ITT/splat/Skypier_L4_ITT_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["6f139264-2bf0-4fc3-ad90-26d77a4534ea"],
      },
      {
        id: "dcbbdc73-ff0e-4417-980a-8a1ca875588c",
        lcMapId: "8efacc25-2e29-46d7-a1d9-553765394580",
        name: "T1 L9 Skybridge",
        shortName: "L9",
        yAxis: 180,
        altitude: 190,
        defaultPosition: [-3106, 190, -5663],
        defaultTarget: [-3111, 190, -5663],
        topViewModel:
          "T1_L9_Sky_Bridge/top_view/T1_L9_Sky_Bridge_top_view_20260903_2030_64tiles.glb",
        meshGround:
          "T1_L9_Sky_Bridge/mesh_ground/T1_L9_Sky_Bridge_mesh_ground_20260903_2030_c.glb",
        lod: "T1_L9_Sky_Bridge/splat/T1_L9_Sky_Bridge_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["8efacc25-2e29-46d7-a1d9-553765394580"],
      },
      {
        id: "dec31274-12a5-4113-addb-edff62922c21",
        lcMapId: "6cdc3838-9ee3-41f9-bac7-b06d07ad6626",
        name: "T1 L6 Skybridge",
        shortName: "L6",
        yAxis: 120,
        altitude: 130,
        defaultPosition: [-2683, 130, -5664],
        defaultTarget: [-2688, 130, -5664],
        topViewModel:
          "T1_L6_Sky_Bridge/top_view/T1_L6_Sky_Bridge_top_view_20260903_2030_64tiles.glb",
        meshGround:
          "T1_L6_Sky_Bridge/mesh_ground/T1_L6_Sky_Bridge_mesh_ground_20260904_1400_c.glb",
        lod: "T1_L6_Sky_Bridge/splat/T1_L6_Sky_Bridge_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["6cdc3838-9ee3-41f9-bac7-b06d07ad6626"],
      },
      {
        ////////////
        id: "e1c8542e-98f5-4d36-bffb-4d926419e0be",
        lcMapId: "9eaf6d0c-f592-441b-8f74-3c0e731a9f53",
        name: "T1 - Skybridge",
        shortName: "L7",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L7_20260824_1530.glb",
        isNotReady: true,
      },
      {
        ////////////
        id: "e48ad7cb-51b1-4a9e-bafb-25badb6ec6e3",
        lcMapId: "98efb970-55e4-49c2-8691-aa4fc3364538",
        name: "T1 Checkin hall -70",
        shortName: "L7",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L7_20260824_1530.glb",
        isNotReady: true,
      },
      {
        id: "e48ad7cb-51b1-4a9e-bafb-25badb6ec6e3",
        lcMapId: "667ff337-140e-45af-bf3d-3a750bf89aee",
        name: "T1 L7 East Hall",
        shortName: "L7",
        yAxis: 140,
        altitude: 150,
        defaultPosition: [-2895, 150, -6380],
        defaultTarget: [-2895, 150, -6375],
        topViewModel:
          "T1_L7_East_Hall/top_view/T1_L7_East_Hall_top_view_20260827_1300_64tiles.glb",
        meshGround:
          "T1_L7_East_Hall/mesh_ground/T1_L7_East_Hall_mesh_ground_20260827_1200_c.glb",
        lod: "T1_L7_East_Hall/splat/T1_L7_East_Hall_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["667ff337-140e-45af-bf3d-3a750bf89aee"],
      },
      {
        ///////////
        id: "e48ad7cb-51b1-4a9e-bafb-25badb6ec6e3",
        lcMapId: "0ed21021-c0cb-47b3-a163-77135df6dcbe",
        name: "T1 - West Hall",
        shortName: "L7",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L7_20260824_1530.glb",
        isNotReady: true,
      },
      {
        id: "e6031da7-08fc-4db7-9ac0-2b8f138deaf1",
        lcMapId: "4eb0a0ed-f244-4e57-828d-7671fd44c578",
        name: "T2 L8 Departure Kerb",
        shortName: "L8",
        yAxis: 160,
        altitude: 166,
        defaultPosition: [-2539, 166, -7535],
        defaultTarget: [-2544, 166, -7535],
        topViewModel:
          "T2_L8_Departure_Kerb/top_view/T2_L8_Departure_Kerb_topview_20260824_1427_64tiles.glb",
        meshGround:
          "T2_L8_Departure_Kerb/mesh_ground/T2_L8_Departure_Kerb_mesh_ground_20260826_2030_c.glb",
        lod: "T2_L8_Departure_Kerb/splat/HKIA_T2_L8_Departure_Kerb_v5_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["4eb0a0ed-f244-4e57-828d-7671fd44c578"],
      },
      {
        id: "ea34f754-4fb9-418e-99ac-05130f1d8e23",
        lcMapId: "d0299b1c-f4d9-46c4-9392-7774988c7a66",
        index: 3,
        name: "T2 L3 Coach Hall",
        shortName: "L3",
        yAxis: 60,
        altitude: 65,
        defaultPosition: [-2545, 65, -7343],
        defaultTarget: [-2545, 65, -7348],
        topViewModel:
          "T2_L3_Coach_Hall/top_view/T2_L3_coach_hall_top_view_20260824_1449_64tiles.glb",
        meshGround:
          "T2_L3_Coach_Hall/mesh_ground/T2_L3_Coach_Hall_With_Middle_Path_mesh_ground_20260826_2230_c.glb",
        lod: "T2_L3_Coach_Hall/splat/HKIA_T2_L3_Coach_Hall_With_Middle_Path_v4_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["d0299b1c-f4d9-46c4-9392-7774988c7a66"],
      },
      {
        id: "f200bad8-65c5-4ce2-ae8e-030bf3c00134",
        lcMapId: "2a85f16c-78fd-4d04-a1ff-f51de23d8706",
        name: "T2 L7 Check-in Hall",
        shortName: "L7",
        yAxis: 140,
        altitude: 146,
        defaultPosition: [-2485, 146, -7690],
        defaultTarget: [-2485, 146, -7695],
        topViewModel:
          "T2_L7_Check_In_Hall/top_view/T2_L7_Check_In_Hall_top_view_20260824_1443_64tiles.glb",
        meshGround:
          "T2_L7_Check_In_Hall/mesh_ground/T2_L7_Check_In_Hall_mesh_ground_20260826_2030_c.glb",
        lod: "T2_L7_Check_In_Hall/splat/HKIA_T2_L7_Check_In_Hall_v3_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["2a85f16c-78fd-4d04-a1ff-f51de23d8706"],
      },
      {
        ///////////
        id: "f66fedce-16fb-4916-b79b-25f41f11ed28",
        lcMapId: "e54e0482-247a-4edf-8e31-d3330c2e0698",
        name: "MFC L4_APV gate area & Floor interchange-40",
        shortName: "L4",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L4_20260824_1530.glb",
        isNotReady: true,
      },
      {
        id: "f860e259-83ad-4f3a-a004-9ae3e1f6c588",
        lcMapId: "131859e9-92af-4e9c-a0c1-1006426d6e17",
        name: "T1 L6 MFC North",
        shortName: "L6",
        yAxis: 120,
        altitude: 130,
        defaultPosition: [-2597, 130, -1020],
        defaultTarget: [-2602, 130, -1020],
        topViewModel:
          "T1_L6_MFC_North/top_view/T1_L6_MFC_North_top_view_20260828_1700_64tiles.glb",
        meshGround:
          "T1_L6_MFC_North/mesh_ground/T1_L6_MFC_A_mesh_ground_20260828_1650_c.glb",
        lod: "T1_L6_MFC_North/splat/T1_L6_MFC_A_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["131859e9-92af-4e9c-a0c1-1006426d6e17"],
      },
      {
        id: "f860e259-83ad-4f3a-a004-9ae3e1f6c588",
        lcMapId: "9024e86e-7fd8-4d6e-88c0-64027284ca15",
        name: "T1 L6 MFC South",
        shortName: "L6",
        yAxis: 120,
        altitude: 130,
        defaultPosition: [-2559, 130, -1020],
        defaultTarget: [-2554, 130, -1020],
        topViewModel:
          "T1_L6_MFC_South/top_view/T1_L6_MFC_South_top_view_20260828_1700_64tiles.glb",
        meshGround:
          "T1_L6_MFC_South/mesh_ground/T1_L6_MFC_B_mesh_ground_20260828_1650_c.glb",
        lod: "T1_L6_MFC_South/splat/T1_L6_MFC_B_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["9024e86e-7fd8-4d6e-88c0-64027284ca15"],
      },
      {
        id: "fa0f596e-d6fd-4171-9dd6-9187863f4517",
        lcMapId: "95f01a90-c388-47bd-8941-d2f58aad6c16",
        name: "T1 L5 NSC",
        shortName: "L5",
        yAxis: 100,
        altitude: 110,
        defaultPosition: [-3670, 110, -5436],
        defaultTarget: [-3665, 110, -5436],
        topViewModel:
          "T1_L5_NSC/top_view/T1_L5_NSC_top_view_20260907_1530_64tiles.glb",
        meshGround:
          "T1_L5_NSC/mesh_ground/T1_L5_NSC_mesh_ground_20260907_1600_c.glb",
        lod: "T1_L5_NSC/splat/T1_L5_NSC_v2_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["95f01a90-c388-47bd-8941-d2f58aad6c16"],
      },
      {
        id: "fdf422f6-2805-4865-a6c3-1c2f856651c1",
        lcMapId: "3815a361-f899-4f0c-af3c-d4150b37a58a",
        name: "T1 L5 Lim, M&G, CP4E",
        shortName: "L5",
        yAxis: 100,
        altitude: 110,
        defaultPosition: [-2595, 110, -6934],
        defaultTarget: [-2595, 110, -6929],
        topViewModel:
          "T1_L5_Lim_MG_CP4E/top_view/T1_L5_Lim_MG_CP4E_top_view_20260902_1650_64tiles.glb",
        meshGround:
          "T1_L5_Lim_MG_CP4E/mesh_ground/T1_L5_Lim_MG_CP4E_mesh_ground_20260902_1700_c.glb",
        lod: "T1_L5_Lim_MG_CP4E/splat/T1_L5_Lim_MG_CP4E_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["3815a361-f899-4f0c-af3c-d4150b37a58a"],
      },
      {
        ///////////
        id: "fdf422f6-2805-4865-a6c3-1c2f856651c1",
        lcMapId: "9f77ade5-aae8-4752-8753-a48dcc9cb402",
        name: "L5 Baggage Reclaim Hall-50",
        shortName: "L5",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L5_20260824_1530.glb",
        isNotReady: true,
      },
      {
        /////////////
        id: "fdf422f6-2805-4865-a6c3-1c2f856651c1",
        lcMapId: "13512d1f-d3c7-4eaf-a3ff-c5db7cb4d702",
        name: "T1  SC, NC & East Hall-50",
        shortName: "L5",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L5_20260824_1530.glb",
        isNotReady: true,
      },
      {
        ////////////
        id: "fdf422f6-2805-4865-a6c3-1c2f856651c1",
        lcMapId: "01f85c32-4fd0-48f5-9a8f-ef2b5ef338d9",
        name: "T1 Central Concourse-50",
        shortName: "L5",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L5_20260824_1530.glb",
        isNotReady: true,
      },
      {
        ////////////
        id: "fdf422f6-2805-4865-a6c3-1c2f856651c1",
        lcMapId: "e5bd679e-5cdc-4f28-beef-1688d42bd06e",
        name: "T1 SouthWest Concourse-50",
        shortName: "L5",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L5_20260824_1530.glb",
        isNotReady: true,
      },
      {
        /////////////
        id: "fdf422f6-2805-4865-a6c3-1c2f856651c1",
        lcMapId: "99d68128-5598-42e2-875b-c6cd8fa692a0",
        name: "T1 NorthWest Concourse-50",
        shortName: "L5",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "global/top_view/HKIA_L5_20260824_1530.glb",
        isNotReady: true,
      },
    ],
  },
};
